
import { defineComponent, getCurrentInstance, computed } from "vue";
import { useStore } from 'vuex';

export default defineComponent({
  name: "authFooterComponent",
  props: {
    activeSection: String,
  },
  setup(){
    const store = useStore();
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    const emitToUsername = () => {
      emitter.emit('SWITCH_TO_USERNAME_LOGIN');
    }
    const appVersion = computed(() => {
      return store.getters['config/appVersion']
    });
    return {
      emitToUsername,
      appVersion
    }
  }
});
